/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/nlp-integration-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { GetLiveTopicsLatestTopicsQueryResponse, GetLiveTopicsLatestTopicsPathParams, GetLiveTopicsLatestTopicsQueryParams } from "../models/GetLiveTopicsLatestTopics";

export function getGetLiveTopicsLatestTopicsUrl(slug: GetLiveTopicsLatestTopicsPathParams["slug"]) {
  const res = { method: 'GET', url: `/live-topics/${slug}/topics/latest` as const }
  return res
}

/**
 * @description Return the latest topics for the channel, ordered by start_time descending.
 * @summary Get latest topics
 * {@link /live-topics/:slug/topics/latest}
 */
export async function getLiveTopicsLatestTopics(slug: GetLiveTopicsLatestTopicsPathParams["slug"], params?: GetLiveTopicsLatestTopicsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLiveTopicsLatestTopicsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetLiveTopicsLatestTopicsUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}